/**
 * Present the outcome tenant creation actually knows.
 *
 * A false `verification_email_sent` is not itself a delivery failure: it is
 * also expected when the operator did not request an invitation, or while a
 * requested invitation is waiting for provisioning readiness.
 */
export const creationInvitationPresentation = ({
  invitation_requested: requested = false,
  verification_email_sent: sent = false,
  admin_user: adminUser = {},
} = {}) => {
  if (!requested) {
    return {
      tone: 'neutral',
      title: 'Invitation not requested',
      detail: 'No invitation was sent. You can send one later from the tenant details page.',
    };
  }

  if (sent) {
    return {
      tone: 'sent',
      title: 'Verification email sent',
      detail: `A verification email was sent to ${adminUser?.email || 'the tenant administrator'}. The link expires in 72 hours.`,
    };
  }

  return {
    tone: 'scheduled',
    title: 'Invitation scheduled',
    detail: 'The invitation will be sent after provisioning and readiness checks complete. Follow its status on the tenant details page.',
  };
};
